module.exports = __webpack_public_path__ + "media/images/icon_category03-a4a9c1c71ce516fe985cef00933067cb.png";